import { render, staticRenderFns } from "./MovilWidget.vue?vue&type=template&id=6aac96fe"
import script from "./MovilWidget.vue?vue&type=script&lang=js"
export * from "./MovilWidget.vue?vue&type=script&lang=js"
import style0 from "./MovilWidget.vue?vue&type=style&index=0&id=6aac96fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports